
import Vue from 'vue';

import TagEditDialog from './TagEditDialog.vue';
import TagInfoDialog from './TagInfoDialog.vue';
import TagDeleteDialog from './TagDeleteDialog.vue';

import { objectsToCSV, filterItem } from '@/utils/Util';

export default Vue.extend({
  name: 'TagsTable',

  components: {
    TagInfoDialog,
    TagEditDialog,
    TagDeleteDialog,
  },
  props: ['tags', 'loading'],
  data: (vm: any): any => ({
    tableLoadingText: vm.loadingText,
    search: '',
    showUUIDs: false,
    numberOfEntities: 0,
    selectedHeaders: [
      { text: vm.$t('attribute.name'), value: 'name', index: 1 },
      { text: vm.$t('attribute.description'), value: 'description', index: 2 },
      { text: vm.$t('attribute.type'), value: 'type', index: 3 },
      { text: vm.$t('attribute.color'), value: 'color', index: 4 },
      { text: vm.$t('attribute.updatedAt'), value: 'updatedAt', index: 8 },
      { text: vm.$t('attribute.createdAt'), value: 'createdAt', index: 9 },
    ],
  }),
  created() {
    if (this.tags.length === 0) {
      this.tableLoadingText = this.$t('tag.noData');
    }

    const columns = this.$root.$store.getters.selectedColumns('tag');
    if (columns) {
      this.selectedHeaders = columns;
    }
  },
  watch: {
    selectedHeaders() {
      this.$store.commit('setSelectedColumns', {
        type: 'tag',
        columns: this.selectedHeaders,
      });
    },
  },
  methods: {
    filterItem,
    onExport() {
      let filteredItems = this.tags;
      if (this.$refs.dataTable.$children[0].filteredItems) {
        filteredItems = this.$refs.dataTable.$children[0].filteredItems;
      }

      // Data structure
      const data = filteredItems.map((conn: any, index: number) =>
        Object({
          uuid: conn.uuid,
          name: conn.name,
          description: conn.description,
          type: conn.type,
          createdAt: conn.createdAt,
          updatedAt: conn.updatedAt,
        })
      );

      const filename = 'bascloud_tags.csv';
      const csvContent = objectsToCSV(data);
      var blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

      if ((navigator as any).msSaveBlob) {
        // IE 10+
        (navigator as any).msSaveBlob(blob, filename);
      } else {
        var link = document.createElement('a');
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', filename);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
    onReload() {
      this.$emit('reload');
    },
    onItemUpdate(item: any) {
      this.$emit('update', item);
    },
    onItemDelete(item: any) {
      this.$emit('delete', item);
    },
    onPaginationAndFilter(pagination: any) {
      this.numberOfEntities = pagination.itemsLength;
    },
    onTableRowClick(row: any) {
      const button: any = this.$refs['tagInfoButton_' + row.uuid];
      // $el needed for native elements
      button.$el.click();
    },
  },
  computed: {
    headers() {
      return [
        { text: this.$t('attribute.name'), value: 'name', index: 1 },
        {
          text: this.$t('attribute.description'),
          value: 'description',
          index: 2,
        },
        { text: this.$t('attribute.type'), value: 'type', index: 3 },
        { text: this.$t('attribute.color'), value: 'color', index: 4 },
        { text: this.$t('attribute.updatedAt'), value: 'updatedAt', index: 8 },
        { text: this.$t('attribute.createdAt'), value: 'createdAt', index: 9 },
      ];
    },
    loadingText(): any {
      return this.$t('loadingData');
    },
    computedTableHeader(): any {
      return [
        ...this.selectedHeaders,
        {
          text: this.$t('attribute.actions'),
          value: 'actions',
          sortable: false,
          filterable: false,
          index: 100,
        },
      ].sort((a: any, b: any) => a.index - b.index);
    },
    canUpdate(): any {
      if (
        this.$root.$store.state.session.permissions.resources &&
        'tags' in this.$root.$store.state.session.permissions.resources
      ) {
        return this.$root.$store.state.session.permissions.resources[
          'tags'
        ].includes('PATCH');
      } else {
        return false;
      }
    },
    canDelete(): any {
      if (
        this.$root.$store.state.session.permissions.resources &&
        'tags' in this.$root.$store.state.session.permissions.resources
      ) {
        return this.$root.$store.state.session.permissions.resources[
          'tags'
        ].includes('DELETE');
      } else {
        return false;
      }
    },
    canCreate(): any {
      if (
        this.$root.$store.state.session.permissions.resources &&
        'tags' in this.$root.$store.state.session.permissions.resources
      ) {
        return this.$root.$store.state.session.permissions.resources[
          'tags'
        ].includes('POST');
      } else {
        return false;
      }
    },
  },
});
